(() => {
  const STORAGE_KEY = 're_tire_compare_v1';
  const MAX_ITEMS = 10;

  const loadList = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  };

  const saveList = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.warn('Compare storage unavailable', e);
    }
  };

  const parsePayload = (id) => {
    const node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      console.warn('Invalid compare payload', e);
      return null;
    }
  };

  const formatValue = (val) => {
    if (val === null || val === undefined || val === '') return '–';

    // If liquid passes objects, render a sensible string if possible
    if (typeof val === 'object') {
      if (Array.isArray(val)) {
        const cleaned = val
          .map((x) => formatValue(x))
          .filter((x) => x && x !== '–');
        return cleaned.length ? cleaned.join(', ') : '–';
      }
      if (val.title) return String(val.title);
      if (val.titel) return String(val.titel); // FIX: German metaobject field ("Saison")
      if (val.name) return String(val.name);
      if (val.label) return String(val.label);
      if (val.handle) return String(val.handle);
      if (val.url) return String(val.url);
      if (val.value !== undefined) return formatValue(val.value);
      return JSON.stringify(val);
    }
    return String(val);
  };

  const resolveProductUrl = (item) => {
    if (!item) return '';
    if (item.product_url) return item.product_url;
    if (item.url) return item.url;
    if (!item.handle) return '';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const rootNormalized = root.endsWith('/') ? root.slice(0, -1) : root;
    return `${rootNormalized}/products/${item.handle}`;
  };

  const buildPayloadMap = () => {
    const map = new Map();
    document.querySelectorAll('script[id^="compare-payload-"]').forEach((node) => {
      try {
        const payload = JSON.parse(node.textContent);
        if (payload?.handle) map.set(payload.handle, payload);
      } catch (e) {}
    });
    return map;
  };

  const enrichListFromDom = (list) => {
    const payloadMap = buildPayloadMap();
    let changed = false;
    const updated = list.map((item) => {
      const payload = payloadMap.get(item.handle);
      if (payload) {
        // Nur schreiben, wenn sich wirklich etwas geaendert hat - sonst laeuft
        // bei jedem Seitenaufruf und jedem MutationObserver-Durchlauf ein
        // ueberfluessiger localStorage-Schreibvorgang.
        if (JSON.stringify(payload) !== JSON.stringify(item)) changed = true;
        return { ...payload };
      }
      return item;
    });
    if (changed) saveList(updated);
    return updated;
  };

  // Setzt Beschriftung + Aktiv-Zustand EINES Buttons.
  // Ausgelagert, damit der geklickte Button sofort umgeschaltet werden kann -
  // unabhaengig davon, ob localStorage verfuegbar ist.
  const applyButtonState = (btn, active) => {
    if (!btn) return;

    const addLabel = btn.dataset.labelAdd || 'Vergleichen';
    const addedLabel = btn.dataset.labelAdded || 'Vergleich entfernen';
    const labelText = active ? addedLabel : addLabel;

    btn.dataset.active = active ? 'true' : 'false';
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-label', labelText);
    btn.title = labelText;

    const labelEl = btn.querySelector('.compare-button__label');
    if (labelEl) labelEl.textContent = labelText;
    else btn.textContent = labelText;
  };

  const syncButtons = () => {
    const list = loadList();
    document.querySelectorAll('.js-compare-button').forEach((btn) => {
      const handle = btn.dataset.compareHandle;
      applyButtonState(btn, list.some((item) => item.handle === handle));
    });

    syncNavCount(list.length);
  };

  const injectButtonIcon = (btn) => {
    if (!btn || btn.querySelector('.compare-button__icon')) return;
    const currentLabel = btn.textContent.trim() || 'Vergleichen';
    const addLabel = btn.dataset.labelAdd || currentLabel || 'Vergleichen';
    const addedLabel = btn.dataset.labelAdded || 'Vergleich entfernen';
    btn.dataset.labelAdd = addLabel;
    btn.dataset.labelAdded = addedLabel;
    btn.setAttribute('aria-label', addLabel);
    btn.innerHTML = '';

    const iconWrap = document.createElement('span');
    iconWrap.className = 'compare-button__icon';
    iconWrap.setAttribute('aria-hidden', 'true');
    iconWrap.innerHTML =
      '<svg class="compare-button__icon-add" viewBox="0 0 16 16" role="presentation" focusable="false"><path d="M3.24 2.48 13 12.24V9.5h1V14a.5.5 0 0 1-.5.5H9v-1h3.3L2.52 3.2l.72-.72Zm9.52-1H9v1h3.3L2.48 12.56l.72.72L13 3.48V6h1V1.5a.5.5 0 0 0-.5-.5Z" /></svg><svg class="compare-button__icon-added" viewBox="0 0 16 16" role="presentation" focusable="false"><path d="M6.5 10.3 3.7 7.5l-.9.9 3.7 3.7 6-6-.9-.9-5.1 5.1Z" /></svg>';

    const labelWrap = document.createElement('span');
    labelWrap.className = 'compare-button__label';
    labelWrap.textContent = addLabel;

    btn.appendChild(iconWrap);
    btn.appendChild(labelWrap);
  };

  const ensureButtonIcons = () => {
    document.querySelectorAll('.js-compare-button').forEach(injectButtonIcon);
  };

  // ---- Hinweis unten ("Zum Vergleich hinzugefügt") ----

  // Anzeigedauer in ms. Der Hinweis pausiert automatisch, solange die Maus
  // darauf liegt oder ein Element darin den Tastaturfokus hat.
  const TOAST_DURATION = 9000;

  // Pfad der Vergleichsseite, ohne führenden Slash.
  const COMPARE_PAGE_PATH = 'pages/reifenvergleich';

  // Markenfarben aus dem Theme (config/settings_data.json):
  //   #334fb4  dunkles Blau  (scheme-5)
  //   #aec8ea  helles Babyblau
  //   #84a0d0  Logo-Blau
  const comparePageUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (root.endsWith('/') ? root : root + '/') + COMPARE_PAGE_PATH;
  };

  // ---- Zaehler am "Reifenvergleich"-Link (Hauptmenue, Drawer, Footer) ----

  const ensureNavCountStyles = () => {
    if (document.getElementById('compare-count-styles')) return;
    const style = document.createElement('style');
    style.id = 'compare-count-styles';
    style.textContent = [
      '.compare-nav-count{',
      'display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;',
      'box-sizing:border-box;min-width:1.9rem;height:1.9rem;',
      'margin-left:0.6rem;padding:0 0.5rem;',
      'border-radius:999px;background:#334fb4;color:#ffffff;',
      'font-family:inherit;font-size:1.1rem;font-weight:700;line-height:1;',
      'letter-spacing:0;text-decoration:none !important;vertical-align:middle;',
      '}',
      '.compare-nav-count[hidden]{display:none;}',
      /* Im mobilen Menue ist die Schrift groesser - der Punkt zieht mit. */
      '.menu-drawer__menu-item .compare-nav-count{',
      'min-width:2.3rem;height:2.3rem;margin-left:0.9rem;font-size:1.3rem;',
      '}'
    ].join('');
    document.head.appendChild(style);
  };

  // Erkennt Links auf die Vergleichsseite anhand des Pfades - unabhaengig
  // davon, ob sie relativ, absolut oder mit Parametern notiert sind.
  const isComparePageLink = (link) => {
    const href = link.getAttribute('href');
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/+$/, '').endsWith('/' + COMPARE_PAGE_PATH);
    } catch (e) {
      return false;
    }
  };

  const syncNavCount = (total) => {
    const slug = COMPARE_PAGE_PATH.split('/').pop();
    const links = document.querySelectorAll('a[href*="' + slug + '"]');
    if (!links.length) return;

    ensureNavCountStyles();

    links.forEach((link) => {
      if (!isComparePageLink(link)) return;

      let badge = link.querySelector('.compare-nav-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'compare-nav-count';
        // Der Hinweis unten meldet die Anzahl bereits per aria-live -
        // hier waere eine zweite Ansage nur doppelt.
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }

      badge.textContent = total;
      badge.hidden = total === 0;
    });
  };

  let toastHideTimer = null;
  let toastRemaining = TOAST_DURATION;
  let toastStartedAt = 0;

  const ensureToastStyles = () => {
    if (document.getElementById('compare-toast-styles')) return;
    const style = document.createElement('style');
    style.id = 'compare-toast-styles';
    style.textContent = [
      /* ---------- Grundgerüst ---------- */
      '.compare-toast{',
      'position:fixed;left:50%;bottom:2.4rem;z-index:900;',
      'box-sizing:border-box;width:min(52rem,calc(100vw - 3.2rem));max-width:calc(100vw - 3.2rem);',
      'display:flex;flex-direction:column;gap:1.2rem;',
      'padding:1.6rem 1.6rem 2.2rem;',
      'border:1px solid #e3e8f2;border-radius:14px;',
      'background:#ffffff;color:#111827;',
      'font-family:inherit;font-size:1.4rem;line-height:1.35;text-align:left;',
      'box-shadow:0 20px 44px rgba(19,38,84,0.18),0 2px 6px rgba(19,38,84,0.08);',
      'opacity:0;visibility:hidden;pointer-events:none;',
      'transform:translate(-50%,1.2rem);',
      'transition:opacity 240ms ease,transform 240ms ease,visibility 0s linear 240ms;',
      '}',
      '.compare-toast.is-visible{',
      'opacity:1;visibility:visible;pointer-events:auto;',
      'transform:translate(-50%,0);transition-delay:0s;',
      '}',

      /* ---------- Kopfzeile ---------- */
      '.compare-toast__head{display:flex;align-items:center;gap:1.2rem;}',
      '.compare-toast__icon{',
      'display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;',
      'width:3.2rem;height:3.2rem;border-radius:999px;background:#aec8ea;color:#1f3576;',
      '}',
      '.compare-toast__icon svg{width:1.8rem;height:1.8rem;fill:currentColor;}',
      '.compare-toast--removed .compare-toast__icon{background:#eef1f7;color:#5b6472;}',
      '.compare-toast__body{flex:1 1 auto;min-width:0;}',
      '.compare-toast__title{margin:0;font-size:1.4rem;font-weight:600;color:#111827;letter-spacing:0;}',
      '.compare-toast__meta{margin:0.2rem 0 0;font-size:1.2rem;font-weight:400;color:#666d76;letter-spacing:0;}',
      '.compare-toast__close{',
      'flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;',
      'width:2.6rem;height:2.6rem;min-height:0;padding:0;margin:0;',
      'border:0;border-radius:999px;background:transparent;color:#8b929b;cursor:pointer;',
      'transition:background-color 160ms ease,color 160ms ease;',
      '}',
      '.compare-toast__close:hover{background:#eef1f7;color:#334fb4;}',
      '.compare-toast__close:focus-visible{outline:2px solid #334fb4;outline-offset:2px;}',
      '.compare-toast__close svg{width:1.3rem;height:1.3rem;fill:currentColor;}',

      /* ---------- Reifen im Vergleich (Bild + Titel) ---------- */
      /* Feste Kachelbreite: die Bilder bleiben immer gleich klein, egal wie  */
      /* viele Reifen im Vergleich liegen. Passt eine Reihe nicht mehr in den */
      /* Hinweis, bricht sie um - es bleibt nichts seitlich verborgen.        */
      '.compare-toast__items{',
      'display:flex;flex-wrap:wrap;gap:0.8rem;margin:0;padding:0;list-style:none;',
      'max-height:24rem;overflow-y:auto;overscroll-behavior-y:contain;',
      'scrollbar-width:thin;scrollbar-color:#cbd5e8 transparent;',
      '}',
      '.compare-toast__items::-webkit-scrollbar{width:4px;}',
      '.compare-toast__items::-webkit-scrollbar-track{background:transparent;}',
      '.compare-toast__items::-webkit-scrollbar-thumb{background:#cbd5e8;border-radius:999px;}',
      '.compare-toast__items[hidden]{display:none;}',
      '.compare-toast__item{flex:0 0 7.6rem;width:7.6rem;}',
      '.compare-toast__item > a,.compare-toast__item > div{',
      'display:block;color:inherit;text-decoration:none !important;',
      '}',
      '.compare-toast__thumb{',
      'display:flex;align-items:center;justify-content:center;box-sizing:border-box;',
      'aspect-ratio:1/1;padding:0.4rem;overflow:hidden;',
      'border:1px solid #dbe4f4;border-radius:8px;background:#f4f7fc;',
      'transition:border-color 160ms ease,box-shadow 160ms ease;',
      '}',
      '.compare-toast__thumb img{display:block;width:100%;height:100%;object-fit:contain;}',
      '.compare-toast__thumb svg{width:2.4rem;height:2.4rem;fill:#aec8ea;}',
      '.compare-toast__name{',
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;',
      'margin:0.4rem 0 0;font-size:1.1rem;line-height:1.25;color:#4b5563;',
      '}',
      '.compare-toast__item > a:hover .compare-toast__thumb{',
      'border-color:#84a0d0;box-shadow:0 4px 10px rgba(51,79,180,0.16);',
      '}',
      '.compare-toast__item > a:hover .compare-toast__name{color:#334fb4;}',
      '.compare-toast__item > a:focus-visible .compare-toast__thumb{outline:2px solid #334fb4;outline-offset:2px;}',

      /* ---------- Schwarzer Button zur Vergleichsseite ---------- */
      '.compare-toast__cta{',
      'display:flex;align-items:center;justify-content:center;gap:0.6rem;',
      'box-sizing:border-box;width:100%;padding:1.2rem 1.6rem;',
      'border:0;border-radius:8px;background:#121212;color:#ffffff !important;',
      'font-size:1.4rem;font-weight:600;line-height:1;white-space:nowrap;',
      'text-decoration:none !important;cursor:pointer;',
      'transition:background-color 160ms ease,transform 160ms ease,box-shadow 160ms ease;',
      '}',
      '.compare-toast__cta:hover{background:#000000;transform:translateY(-1px);box-shadow:0 8px 18px rgba(18,18,18,0.24);}',
      '.compare-toast__cta:focus-visible{outline:2px solid #334fb4;outline-offset:2px;}',
      '.compare-toast__cta svg{width:1.1rem;height:1.1rem;fill:currentColor;flex:0 0 auto;}',
      '.compare-toast__cta[hidden]{display:none;}',

      /* ---------- Restlaufzeit-Balken ---------- */
      '.compare-toast__progress{',
      'position:absolute;left:1.6rem;right:1.6rem;bottom:0.9rem;',
      'height:2px;border-radius:999px;background:#eef1f7;overflow:hidden;',
      '}',
      '.compare-toast__progress i{',
      'display:block;height:100%;width:100%;background:#334fb4;',
      'transform-origin:left center;animation:compare-toast-progress linear forwards;',
      '}',
      '.compare-toast--removed .compare-toast__progress i{background:#b9bec4;}',
      '@keyframes compare-toast-progress{from{transform:scaleX(1);}to{transform:scaleX(0);}}',

      /* ---------- Mobil ---------- */
      '@media screen and (max-width:749px){',
      '.compare-toast{',
      'left:1.2rem;right:1.2rem;width:auto;',
      'bottom:calc(1.2rem + env(safe-area-inset-bottom,0px));',
      'padding:1.4rem 1.4rem 2.2rem;transform:translate(0,1.2rem);',
      '}',
      '.compare-toast.is-visible{transform:translate(0,0);}',
      '.compare-toast__icon{width:2.8rem;height:2.8rem;}',
      '.compare-toast__close{width:3.2rem;height:3.2rem;}',
      '.compare-toast__items{gap:0.6rem;max-height:20rem;}',
      '.compare-toast__item{flex:0 0 6rem;width:6rem;}',
      '.compare-toast__name{font-size:1rem;}',
      '.compare-toast__cta{padding:1.4rem;}',
      '.compare-toast__progress{left:1.4rem;right:1.4rem;}',
      '}',

      /* ---------- Reduzierte Bewegung ---------- */
      '@media (prefers-reduced-motion:reduce){',
      '.compare-toast{transform:translate(-50%,0);transition:opacity 120ms linear,visibility 0s linear 120ms;}',
      '.compare-toast.is-visible{transform:translate(-50%,0);}',
      '.compare-toast__cta:hover{transform:none;}',
      '}',
      '@media screen and (max-width:749px) and (prefers-reduced-motion:reduce){',
      '.compare-toast,.compare-toast.is-visible{transform:translate(0,0);}',
      '}'
    ].join('');
    document.head.appendChild(style);
  };

  const hideToast = () => {
    clearTimeout(toastHideTimer);
    toastHideTimer = null;
    const toast = document.getElementById('compare-toast');
    if (toast) toast.classList.remove('is-visible');
  };

  const pauseToast = () => {
    if (!toastHideTimer) return;
    clearTimeout(toastHideTimer);
    toastHideTimer = null;
    toastRemaining = Math.max(600, toastRemaining - (Date.now() - toastStartedAt));

    const bar = document.querySelector('#compare-toast .compare-toast__progress i');
    if (bar) bar.style.animationPlayState = 'paused';
  };

  const resumeToast = () => {
    // focusout feuert, bevor der neue Fokus gesetzt ist - deshalb ein Tick warten.
    setTimeout(() => {
      const toast = document.getElementById('compare-toast');
      if (!toast || !toast.classList.contains('is-visible') || toastHideTimer) return;
      if (toast.matches(':hover') || toast.contains(document.activeElement)) return;

      const bar = toast.querySelector('.compare-toast__progress i');
      if (bar) bar.style.animationPlayState = 'running';

      toastStartedAt = Date.now();
      toastHideTimer = setTimeout(hideToast, toastRemaining);
    }, 0);
  };

  const buildToast = () => {
    const toast = document.createElement('div');
    toast.id = 'compare-toast';
    toast.className = 'compare-toast';
    toast.setAttribute('role', 'region');
    toast.setAttribute('aria-label', 'Reifenvergleich');
    toast.innerHTML = [
      '<div class="compare-toast__head">',
      '<span class="compare-toast__icon" aria-hidden="true">',
      '<svg viewBox="0 0 16 16" focusable="false"><path d="M6.5 10.3 3.7 7.5l-.9.9 3.7 3.7 6-6-.9-.9-5.1 5.1Z"/></svg>',
      '</span>',
      '<div class="compare-toast__body" role="status" aria-live="polite">',
      '<p class="compare-toast__title"></p>',
      '<p class="compare-toast__meta"></p>',
      '</div>',
      '<button type="button" class="compare-toast__close" aria-label="Hinweis schließen">',
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m12.7 4.2-.9-.9L8 7.1 4.2 3.3l-.9.9L7.1 8l-3.8 3.8.9.9L8 8.9l3.8 3.8.9-.9L8.9 8l3.8-3.8Z"/></svg>',
      '</button>',
      '</div>',
      '<ul class="compare-toast__items"></ul>',
      '<a class="compare-toast__cta" href="#">',
      '<span class="compare-toast__cta-label">Jetzt vergleichen</span>',
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6.2 3.3 5.3 4.2 9.1 8l-3.8 3.8.9.9L11 8 6.2 3.3Z"/></svg>',
      '</a>',
      '<span class="compare-toast__progress" aria-hidden="true"><i></i></span>'
    ].join('');

    toast.querySelector('.compare-toast__close').addEventListener('click', hideToast);
    toast.addEventListener('mouseenter', pauseToast);
    toast.addEventListener('mouseleave', resumeToast);
    toast.addEventListener('focusin', pauseToast);
    toast.addEventListener('focusout', resumeToast);

    document.body.appendChild(toast);
    return toast;
  };

  const getToast = () => document.getElementById('compare-toast') || buildToast();

  // Ein Kästchen je Reifen, der aktuell im Vergleich liegt: Bild + Titel,
  // verlinkt auf die jeweilige Produktseite.
  const renderToastItems = (container, list) => {
    if (!container) return;

    container.innerHTML = '';
    container.hidden = !list.length;
    if (!list.length) return;

    list.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'compare-toast__item';

      const url = resolveProductUrl(item);
      const link = document.createElement(url ? 'a' : 'div');
      if (url) {
        link.href = url;
        link.rel = 'noopener';
      }

      const thumb = document.createElement('span');
      thumb.className = 'compare-toast__thumb';

      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        thumb.appendChild(img);
      } else {
        thumb.innerHTML =
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 2.2A4.8 4.8 0 1 1 3.2 8 4.8 4.8 0 0 1 8 3.2Zm0 2.6A2.2 2.2 0 1 0 10.2 8 2.2 2.2 0 0 0 8 5.8Z"/></svg>';
      }

      const name = document.createElement('span');
      name.className = 'compare-toast__name';
      name.textContent = item.title || item.handle || 'Reifen';

      link.appendChild(thumb);
      link.appendChild(name);
      li.appendChild(link);
      container.appendChild(li);
    });
  };

  /**
   * variant:       'added' | 'removed'
   * list:          die Reifen, die nach der Aktion im Vergleich liegen
   * limitReached:  true, wenn wegen MAX_ITEMS der aelteste Reifen rausgefallen ist
   */
  const showToast = (variant, list, limitReached) => {
    ensureToastStyles();

    const toast = getToast();
    const added = variant !== 'removed';
    const items = Array.isArray(list) ? list : loadList();
    const total = items.length;

    toast.className = 'compare-toast compare-toast--' + (added ? 'added' : 'removed');

    toast.querySelector('.compare-toast__title').textContent = added
      ? 'Zum Vergleich hinzugefügt'
      : 'Aus dem Vergleich entfernt';

    let meta;
    if (limitReached) {
      meta = 'Maximal ' + MAX_ITEMS + ' Reifen – der zuerst gewählte wurde entfernt.';
    } else if (total === 0) {
      meta = 'Keine Reifen mehr im Vergleich';
    } else if (total === 1) {
      meta = '1 Reifen im Vergleich';
    } else {
      meta = total + ' Reifen im Vergleich';
    }
    toast.querySelector('.compare-toast__meta').textContent = meta;

    const itemsEl = toast.querySelector('.compare-toast__items');
    renderToastItems(itemsEl, items);

    // Der zuletzt gewaehlte Reifen steht vorne in der Liste - immer nach oben
    // zurueckspringen, damit er sichtbar ist.
    if (itemsEl) itemsEl.scrollTop = 0;

    const cta = toast.querySelector('.compare-toast__cta');
    cta.href = comparePageUrl();
    cta.hidden = total === 0;
    cta.querySelector('.compare-toast__cta-label').textContent =
      total > 1 ? 'Jetzt vergleichen' : 'Zum Reifenvergleich';

    // Restlaufzeit-Balken neu starten - auch bei schnellen Mehrfachklicks.
    const bar = toast.querySelector('.compare-toast__progress i');
    if (bar) {
      bar.style.animation = 'none';
      bar.style.animationPlayState = 'running';
      void bar.offsetWidth;
      bar.style.animation = '';
      bar.style.animationDuration = TOAST_DURATION + 'ms';
    }

    toast.classList.add('is-visible');

    toastRemaining = TOAST_DURATION;
    toastStartedAt = Date.now();
    clearTimeout(toastHideTimer);
    toastHideTimer = setTimeout(hideToast, TOAST_DURATION);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const toast = document.getElementById('compare-toast');
    if (toast && toast.classList.contains('is-visible')) hideToast();
  });

  // ---- Helpers ----

  const getByPath = (obj, path) => {
    if (!obj || !path) return null;
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), obj);
  };

  const unwrapMetafieldValue = (val) => {
    if (val === null || val === undefined) return null;
    if (typeof val !== 'object') return val;
    if (val.value !== undefined) return val.value;
    return val;
  };

  // normalize keys: makes "Reifendurchmesser" match "reifendurchmesser" or "custom.reifendurchmesser"
  const normalizeKey = (s) => {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ''); // remove dots, spaces, underscores, etc.
  };

  // robust: supports mf["custom.key"], mf["custom:key"], mf["key"], mf.custom.key, mf array
  // + tolerant fallback search by normalized key (case-insensitive, ignores dots/spaces)
  const getMetafieldValue = (item, namespace, key) => {
    if (!item || !item.metafields) return null;

    const mf = item.metafields;
    const ns = (namespace || '').trim();
    const k = (key || '').trim();
    if (!k) return null;

    const combinedDot = ns ? `${ns}.${k}` : k;
    const combinedColon = ns ? `${ns}:${k}` : k;
    const combinedUnderscore = ns ? `${ns}_${k}` : k;

    if (typeof mf === 'object' && !Array.isArray(mf)) {
      // direct hits
      if (mf[combinedDot] !== undefined) return unwrapMetafieldValue(mf[combinedDot]);
      if (mf[combinedColon] !== undefined) return unwrapMetafieldValue(mf[combinedColon]);
      if (mf[combinedUnderscore] !== undefined) return unwrapMetafieldValue(mf[combinedUnderscore]);
      if (mf[k] !== undefined) return unwrapMetafieldValue(mf[k]);

      if (ns && mf[ns] && typeof mf[ns] === 'object') {
        const nsObj = mf[ns];
        if (nsObj[k] !== undefined) return unwrapMetafieldValue(nsObj[k]);
      }

      // tolerant lookup by normalized key
      const want = normalizeKey(k);
      const wantWithNs = ns ? normalizeKey(`${ns}.${k}`) : null;

      for (const rawKey of Object.keys(mf)) {
        const rawNorm = normalizeKey(rawKey);
        if (rawNorm === want || (wantWithNs && rawNorm === wantWithNs)) {
          return unwrapMetafieldValue(mf[rawKey]);
        }

        // also compare only the "last segment" of keys like "custom.reifendurchmesser"
        const lastSegment = rawKey.split('.').pop();
        if (normalizeKey(lastSegment) === want) {
          return unwrapMetafieldValue(mf[rawKey]);
        }
      }

            // FIX: last resort - one key is a PREFIX of the other, in either direction.
      // Only used when UNAMBIGUOUS, i.e. exactly one payload key matches.
      if (want.length >= 3) {
        const prefixHits = Object.keys(mf).filter((rawKey) => {
          const rawNorm = normalizeKey(rawKey);
          if (rawNorm.length < 3) return false;
          return rawNorm.startsWith(want) || want.startsWith(rawNorm);
        });
        if (prefixHits.length === 1) {
          return unwrapMetafieldValue(mf[prefixHits[0]]);
        }
      }
    }

    if (Array.isArray(mf)) {
      const found = mf.find((x) => x && normalizeKey(x.key) === normalizeKey(k) && (!ns || x.namespace === ns));
      if (found) return unwrapMetafieldValue(found.value !== undefined ? found.value : found);
    }

    return null;
  };

  /**
   * Metaobject resolver:
   * 1) primary: item.metaobjects["product:custom.reifenhersteller"][field]
   * 2) fallback: if metafield value is already an object, read that[field]
   */
  const getMetaobjectValue = (item, scope, namespace, key, field) => {
    const sc = (scope || 'product').trim();
    const ns = (namespace || '').trim();
    const k = (key || '').trim();
    const f = (field || '').trim();
    if (!ns || !k || !f) return null;

    // 1) from explicit metaobjects map (optional)
    if (item && item.metaobjects && typeof item.metaobjects === 'object') {
      const lookupKey = `${sc}:${ns}.${k}`; // e.g. "product:custom.reifenhersteller"
      const mo = item.metaobjects[lookupKey];
      if (mo && mo[f] !== undefined) return unwrapMetafieldValue(mo[f]);
    }

    // 2) fallback: metafield value is already an object (metaobject reference)
    const mfVal = getMetafieldValue(item, ns, k);
    if (mfVal && typeof mfVal === 'object') {
      if (mfVal[f] !== undefined) return unwrapMetafieldValue(mfVal[f]);
      // common fallbacks
      if (f === 'title' && mfVal.title) return mfVal.title;
      if (f === 'title' && mfVal.titel) return mfVal.titel;
      if (f === 'name' && mfVal.name) return mfVal.name;
      if (f === 'handle' && mfVal.handle) return mfVal.handle;
    }

    return null;
  };

  const renderRowHeader = (row) => {
    const wrap = document.createElement('div');
    wrap.className = 'compare-rowhead';

    if (row && row.icon_image) {
      const img = document.createElement('img');
      img.className = 'compare-rowhead__icon';
      img.src = row.icon_image;
      img.alt = '';
      img.loading = 'lazy';
      wrap.appendChild(img);
    } else if (row && row.icon_badge) {
      const badge = document.createElement('span');
      badge.className = 'compare-rowhead__badge';
      badge.textContent = row.icon_badge;
      wrap.appendChild(badge);
    }

    const text = document.createElement('span');
    text.className = 'compare-rowhead__label';
    text.textContent = row && row.label ? row.label : '–';
    wrap.appendChild(text);

    return wrap;
  };

  const renderCompareTable = () => {
    const container = document.querySelector('[data-compare-table]');
    if (!container) return;

    const configId = container.getAttribute('data-compare-fields');
    let configuredRows = [];
    if (configId) {
      const configScript = document.getElementById(configId);
      if (configScript) {
        try {
          const parsed = JSON.parse(configScript.textContent || '[]');
          configuredRows = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.warn('Invalid compare fields config JSON', e);
        }
      }
    }

    const list = enrichListFromDom(loadList());
    container.innerHTML = '';

    if (!list.length) {
      const empty = document.createElement('div');
      empty.className = 'compare-empty';
      empty.textContent = 'Füge Produkte über „Vergleichen“ hinzu.';
      container.appendChild(empty);
      return;
    }

    const table = document.createElement('table');
    table.className = 'compare-table__grid';
    table.style.setProperty('--compare-columns', list.length);

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');

    const spacer = document.createElement('th');
    spacer.textContent = '';
    headRow.appendChild(spacer);

    list.forEach((item) => {
      const th = document.createElement('th');
      const head = document.createElement('div');
      head.className = 'compare-head';
      const productUrl = resolveProductUrl(item);

      if (item.image) {
        const imgWrap = productUrl ? document.createElement('a') : document.createElement('div');
        imgWrap.className = productUrl ? 'compare-head__link' : 'compare-head__link compare-head__link--static';
        if (productUrl) {
          imgWrap.href = productUrl;
          imgWrap.target = '_self';
          imgWrap.rel = 'noopener';
          imgWrap.setAttribute('aria-label', item.title || item.handle || 'Produktbild');
        }
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || item.handle || 'Produktbild';
        imgWrap.appendChild(img);
        head.appendChild(imgWrap);
      }

      const titleEl = productUrl ? document.createElement('a') : document.createElement('div');
      titleEl.className = 'compare-title' + (productUrl ? ' compare-title--link' : '');
      titleEl.textContent = item.title || item.handle || 'Produkt';
      if (productUrl) {
        titleEl.href = productUrl;
        titleEl.target = '_self';
        titleEl.rel = 'noopener';
      }
      head.appendChild(titleEl);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'compare-remove';
      remove.dataset.handle = item.handle;
      remove.textContent = 'Entfernen';
      head.appendChild(remove);

      // ----------------------------------------------------------------
      // Menge + "In den Warenkorb" (eine Zeile, bewusst zurueckhaltend)
      //
      // Die Variante steht im Payload (snippets/compare-button.liquid ->
      // "variant": { "id": ... }). Fehlt sie, wird der Bereich einfach
      // weggelassen - die Tabelle funktioniert dann wie bisher.
      // ----------------------------------------------------------------
      const variantId = item.variant && item.variant.id;

      if (variantId) {
        const qtyInput = document.createElement('input');
        qtyInput.type = 'number';
        qtyInput.className = 'compare-qty__input';
        qtyInput.value = '4';  // Standard: ein kompletter Satz
        qtyInput.min = '1';
        qtyInput.max = '99';
        qtyInput.step = '1';
        qtyInput.inputMode = 'numeric';
        qtyInput.setAttribute('aria-label', 'Menge');

        // Haelt die Eingabe in den Grenzen und gibt die gueltige Zahl zurueck.
        const clampQty = () => {
          let n = parseInt(qtyInput.value, 10);
          if (!n || n < 1) n = 1;
          if (n > 99) n = 99;
          qtyInput.value = String(n);
          return n;
        };

        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'compare-qty__btn';
        minus.textContent = '\u2212';
        minus.setAttribute('aria-label', 'Menge verringern');
        minus.addEventListener('click', () => {
          qtyInput.value = String(Math.max(1, clampQty() - 1));
        });

        const plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'compare-qty__btn';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Menge erhöhen');
        plus.addEventListener('click', () => {
          qtyInput.value = String(Math.min(99, clampQty() + 1));
        });

        qtyInput.addEventListener('change', clampQty);

        const stepper = document.createElement('div');
        stepper.className = 'compare-qty';
        stepper.appendChild(minus);
        stepper.appendChild(qtyInput);
        stepper.appendChild(plus);

        // Knopf: Symbol + Text. Auf dem Handy blendet das CSS den Text aus,
        // damit alles in einer Zeile bleibt - das Symbol traegt dann allein.
        const addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'compare-addtocart';
        addBtn.setAttribute('aria-label', 'In den Warenkorb');
        addBtn.innerHTML =
          '<svg class="compare-addtocart__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
          '<path d="M5.5 4.5V4a2.5 2.5 0 0 1 5 0v.5h2.1l.6 8.2a2 2 0 0 1-2 2.1H4.8a2 2 0 0 1-2-2.1l.6-8.2zm1 0h3V4a1.5 1.5 0 0 0-3 0zm-2.2 1-.5 7.3a1 1 0 0 0 1 1.1h6.4a1 1 0 0 0 1-1.1l-.5-7.3z"/>' +
          '</svg><span class="compare-addtocart__label">In den Warenkorb</span>';

        const setLabel = (text) => {
          const el = addBtn.querySelector('.compare-addtocart__label');
          if (el) el.textContent = text;
        };

        addBtn.addEventListener('click', () => {
          const menge = clampQty();

          // Dawn-Warenkorb der Seite: Drawer oder Benachrichtigung.
          // Beide liefern ueber getSectionsToRender(), welche Section-Teile
          // die Antwort mitbringen muss - erst damit kann renderContents()
          // den Warenkorb neu zeichnen UND einschieben.
          const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections =
            cartEl && typeof cartEl.getSectionsToRender === 'function'
              ? cartEl.getSectionsToRender().map((section) => section.id)
              : [];

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const base = root.endsWith('/') ? root : root + '/';

          addBtn.disabled = true;
          addBtn.classList.add('is-busy');
          setLabel('Wird hinzugefügt …');

          fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: menge }],
              sections: sections,
              sections_url: window.location.pathname
            })
          })
            .then((res) => (res.ok ? res.json() : Promise.reject(res)))
            .then((data) => {
              addBtn.classList.remove('is-busy');
              addBtn.classList.add('is-done');
              setLabel('Im Warenkorb ✓');

              if (cartEl && typeof cartEl.renderContents === 'function' && data && data.sections) {
                // War der Warenkorb beim Laden der Seite leer, traegt das
                // <cart-drawer> die Klasse "is-empty". Dawn entfernt sie nur
                // an ".drawer__inner" - hier sitzt sie aber am Element selbst,
                // und das CSS blendet damit den Inhalt aus ("display:none").
                // Ohne diese Zeile schiebt sich ein leerer Warenkorb ein.
                cartEl.classList.remove('is-empty');

                // Zeichnet Warenkorb und Zahl im Header neu - und oeffnet ihn.
                if (typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(addBtn);
                cartEl.renderContents(data);
                return;
              }

              // Fallback ohne Drawer: wenigstens die Zahl am Symbol nachziehen.
              return fetch(base + 'cart.js')
                .then((res) => res.json())
                .then((cart) => {
                  const host = document.getElementById('cart-icon-bubble');
                  if (!host) return;
                  let bubble = host.querySelector('.cart-count-bubble');
                  if (!bubble) {
                    bubble = document.createElement('div');
                    bubble.className = 'cart-count-bubble';
                    host.appendChild(bubble);
                  }
                  bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
                })
                .catch(() => {});
            })
            .catch(() => {
              addBtn.classList.remove('is-busy');
              setLabel('Nicht möglich');
            })
            .then(() => {
              setTimeout(() => {
                setLabel('In den Warenkorb');
                addBtn.classList.remove('is-done', 'is-busy');
                addBtn.disabled = false;
              }, 2200);
            });
        });

        const cartBox = document.createElement('div');
        cartBox.className = 'compare-cart';
        cartBox.appendChild(stepper);
        cartBox.appendChild(addBtn);
        head.appendChild(cartBox);
      }

      th.appendChild(head);
      headRow.appendChild(th);
    });

    thead.appendChild(headRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');

    const rowsToRender =
      configuredRows && configuredRows.length
        ? configuredRows
        : [{ label: 'Preis', type: 'base', base_field: 'variant.price' }];

    rowsToRender.forEach((row) => {
      const tr = document.createElement('tr');

      const th = document.createElement('th');
      th.appendChild(renderRowHeader(row));
      tr.appendChild(th);

      list.forEach((item) => {
        const td = document.createElement('td');
        td.className = 'compare-value';

        let value = null;

        if (row.type === 'base') {
          value = getByPath(item, row.base_field);
        } else if (row.type === 'metaobject') {
          value = getMetaobjectValue(item, row.scope, row.namespace, row.key, row.metaobject_field);
        } else {
          value = getMetafieldValue(item, row.namespace, row.key);
        }

        td.textContent = formatValue(value);
        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    container.appendChild(table);

    container.querySelectorAll('.compare-remove').forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.handle;
        const updated = loadList().filter((item) => item.handle !== handle);
        saveList(updated);
        syncButtons();
        renderCompareTable();
      });
    });
  };

  // FIX: event delegation - works for buttons that are added to the DOM later
  // (facet filtering, "load more", quick view) without any re-binding.
  const handleButtonClick = (event) => {
    const btn = event.target.closest && event.target.closest('.js-compare-button');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const payload = parsePayload(btn.dataset.compareJson);
    if (!payload) return;

    let list = loadList();
    const existingIndex = list.findIndex((item) => item.handle === payload.handle);
    let wasAdded;
    let limitReached = false;

    if (existingIndex > -1) {
      list.splice(existingIndex, 1);
      wasAdded = false;
    } else {
      list.unshift(payload);
      wasAdded = true;
      if (list.length > MAX_ITEMS) {
        list = list.slice(0, MAX_ITEMS);
        limitReached = true;
      }
    }

    // 1) Sofortiges Feedback am geklickten Button - noch vor jedem Speicher-Zugriff.
    //    Dadurch wechselt die Beschriftung ("Vergleichen" -> "Im Vergleich")
    //    garantiert im selben Moment, in dem geklickt wird.
    applyButtonState(btn, wasAdded);

    // 2) Persistieren und alle uebrigen Buttons derselben Seite angleichen.
    saveList(list);
    syncButtons();
    renderCompareTable();

    // 3) Hinweis unten einblenden.
    showToast(wasAdded ? 'added' : 'removed', list, limitReached);
  };

  // ---- Preise und Verfuegbarkeit beim Oeffnen der Vergleichsseite pruefen ----
  //
  // Die Vergleichsseite enthaelt keine compare-payload-Scripts, deshalb findet
  // enrichListFromDom() dort nichts zum Auffrischen. Ohne diesen Schritt zeigt
  // die Tabelle die Preise, die beim Klick auf "Vergleichen" gespeichert
  // wurden - das koennen Wochen sein.
  //
  // /products/<handle>.js liefert Preise in Cent. Produkte, die es nicht mehr
  // gibt (404), fliegen aus der Liste.
  const formatMoney = (cents) => {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '–';
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return amount.toLocaleString('de-DE', { style: 'currency', currency: currency });
  };

  const revalidateList = async () => {
    const list = loadList();
    if (!list.length) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = root.endsWith('/') ? root : root + '/';

    const results = await Promise.all(
      list.map(async (item) => {
        if (!item || !item.handle) return item;

        try {
          const res = await fetch(
            base + 'products/' + encodeURIComponent(item.handle) + '.js',
            { credentials: 'same-origin', headers: { Accept: 'application/json' } }
          );

          if (res.status === 404) return null;
          if (!res.ok) return item;

          const live = await res.json();
          const variants = live.variants || [];
          const variant =
            variants.find((v) => item.variant && v.id === item.variant.id) ||
            variants.find((v) => v.available) ||
            variants[0];

          if (!variant) return null;

          return Object.assign({}, item, {
            title: live.title || item.title,
            url: live.url || item.url,
            price: formatMoney(variant.price),
            price_raw: variant.price,
            variant: Object.assign({}, item.variant || {}, {
              id: variant.id,
              sku: variant.sku,
              price: formatMoney(variant.price),
              price_raw: variant.price,
              available: variant.available
            })
          });
        } catch (e) {
          // Netzwerkfehler: lieber den alten Eintrag behalten als ihn zu verlieren.
          return item;
        }
      })
    );

    const cleaned = results.filter(Boolean);
    saveList(cleaned);
    syncButtons();
    renderCompareTable();
  };


  const attachButtons = () => {
    ensureButtonIcons();
  };

  const init = () => {
    enrichListFromDom(loadList());
    attachButtons();
    syncButtons();
    renderCompareTable();
  };

  // FIX: setTimeout instead of requestAnimationFrame.
  // rAF never fires in a background tab, which left the old boolean flag stuck
  // on `true` forever - every later refresh was then silently skipped.
  let compareRefreshTimer = null;

  const scheduleCompareRefresh = () => {
    if (compareRefreshTimer !== null) return;

    compareRefreshTimer = setTimeout(() => {
      compareRefreshTimer = null;

      enrichListFromDom(loadList());
      attachButtons();
      syncButtons();
    }, 50);
  };

  const compareObserver = new MutationObserver((mutations) => {
    const hasNewCompareButtons = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;

        return (
          node.matches('.js-compare-button') ||
          node.querySelector('.js-compare-button') !== null
        );
      })
    );

    if (hasNewCompareButtons) {
      scheduleCompareRefresh();
    }
  });

    const startCompare = () => {
    init();

    // Nur auf der Vergleichsseite: gespeicherte Preise gegen den Shop pruefen.
    // Ueberall sonst frischt enrichListFromDom() aus den Produktkarten auf.
    if (document.querySelector('[data-compare-table]')) revalidateList();

    compareObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // Single delegated listener - bound once, independent of page state.
  document.addEventListener('click', handleButtonClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCompare, {
      once: true
    });
  } else {
    startCompare();
  }

  document.addEventListener('shopify:section:load', scheduleCompareRefresh);

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY || event.key === null) {
      syncButtons();
      renderCompareTable();
    }
  });

  // Zurueck-Navigation aus dem bfcache (Browser-Zurueck-Button) und
  // Rueckkehr in den Tab: Button-Zustand erneut aus dem Speicher herstellen.
  window.addEventListener('pageshow', () => {
    syncButtons();
    renderCompareTable();
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncButtons();
  });
})();